import React from 'react';
import ALocaleProvider from 'antd-mobile/lib/locale-provider';



export default class LocaleProvider extends ALocaleProvider {}